export default class RemoveProductCart
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    
    this.remove_products_cart = document.querySelectorAll('.woo__cartButton--remove' );
    
    if (!this.remove_products_cart) return;
    
    return true;
  }
  
  setEvents()
  {
    this.remove_products_cart.forEach(product => {
      product.addEventListener('click', () => {
        setTimeout(() => {
          location.reload();
        }, 1000)
      })
    });
  }
}
